import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PswdReset } from "../../../../store";
import { ResetPassword } from "../../../../api";
import Grid from "@mui/material/Grid";  //FB 7111
import useMediaQuery from "@mui/material/useMediaQuery";
//FB 7111
import { Button, InputAdornment, TextField, Typography } from "@mui/material";
import StrengthMeter from "../../../../components/PasswordStrengthMeter";
import { CheckCircle } from "@mui/icons-material";
import useStyles from "../../../../css/styles";

// Update log
// FB  6192   02/06/2023  DK   Added page for settings
// FB  7111   07/25/2023  DK   Password strength meter and green tick feature
// FB  7874   12/07/2023  DK  Admin should be able to access patient pages
// FB  8568   04/16/2024  DK  Guardian is not able to see the patient profile details

//FB 7874
export default function Settings(props: any) {
  const styles = useStyles(); //FB 7111
  const matches = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const JSAlert = require("js-alert");
  const [login, setLogin] = useState("");
  const [passwordFromSession, setPasswordFromSession] = useState("");  //FB 7874
  //FB 7111
  const [pswdResetForm, setPswdResetForm] = useState({ Password: "", NewPassword: "", ConfirmPassword: "" } as PswdReset);
  const [errors, setErrors] = useState({
    Password: false,
    NewPassword: false,
    ConfirmPassword: false,
  });
  const [isDisabled, setIsDisabled] = React.useState(true);
  const [isCriteriaMet, setIsCriteriaMet] = useState(false);  //FB 7111
  const [isGuardian, setIsGuardian] = useState(false);  //FB 8568
  const handleInputChange = (e: any) => {
    setErrors({ ...errors, [e.target.name]: false });
    setPswdResetForm({ ...pswdResetForm, [e.target.name]: e.target.value });
    if (pswdResetForm.Password != null && pswdResetForm.NewPassword != null) {
      setIsDisabled(false);
    }
  };
  const text = {
    container: {
      borderRadius: "5px",
      height: "35px",
      fontSize: "25px",
      width: matches == false ? "calc(100%)" : "410px",
    },
  };
  const styletwo = {
    container: {
      border: "1px grey",
      marginLeft: matches == false ? "16px" : "40px",
      marginTop: "20px",
      marginRight: matches == false ? "16px" : "0px",
      marginBottom: "20px",
    },
  };
  const validate = () => {
    if (pswdResetForm.Password == undefined || pswdResetForm.Password === "") {
      setErrors((errors) => ({ ...errors, Password: true }));
      return false;
    }
    if (
      pswdResetForm.NewPassword == undefined ||
      pswdResetForm.NewPassword === ""
    ) {
      setErrors((errors) => ({ ...errors, NewPassword: true }));
      return false;
    }
    if (
      pswdResetForm.ConfirmPassword == undefined ||
      pswdResetForm.ConfirmPassword === ""
    ) {
      setErrors((errors) => ({ ...errors, ConfirmPassword: true }));
      return false;
    }
    return true;
  };

  async function getDetails() {
    var data = sessionStorage.getItem("user");
    if (data != null) {
      const user = JSON.parse(data);
      if (user.Patient_n != null) {
        setLogin(user.Login);
        setIsGuardian(user.IsGuardian); //FB 8568
        setPasswordFromSession(user.Password);  //FB 7874
      }
    }
  }

  const handleReset = async (e: any) => {
    e.preventDefault();
    //FB 7111
    var regex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9\\s])(?=.{8,})");
    //FB 7874
    if (props.userType === "patient" && (pswdResetForm.Password == undefined || pswdResetForm.Password === "")) {
      JSAlert.alert(
        "Please enter the current Password",
        null,
        JSAlert.Icons.Failed
      );
    } else if (
      pswdResetForm.NewPassword == undefined ||
      pswdResetForm.NewPassword === ""
    ) {
      JSAlert.alert(
        "Please enter the New Password",
        null,
        JSAlert.Icons.Failed
      );
    } else if (
      pswdResetForm.ConfirmPassword === undefined ||
      pswdResetForm.ConfirmPassword === ""
    ) {
      JSAlert.alert(
        "Please enter the Confirm Password",
        null,
        JSAlert.Icons.Failed
      );
    } else if (!pswdResetForm.NewPassword.match(regex)) {
      JSAlert.alert(
        "Password does not match the criteria",
        null,
        JSAlert.Icons.Failed
      );
    } else {
      if (pswdResetForm.NewPassword == pswdResetForm.ConfirmPassword) {
        //FB 7874
        let response = await ResetPassword(
          login,
          props.userType == "admin" ? passwordFromSession : pswdResetForm.Password,
          pswdResetForm.NewPassword,
          props.userType
        );
        if (response != null) {
          if (response.alertType == "Success") {
            JSAlert.alert(response.message, null, JSAlert.Icons.Success).then(
              function () {
                navigate("/user/login");
              }
            );
          } else {
            JSAlert.alert(response.message, null, JSAlert.Icons.Failed).then(
              function () {
                window.location.reload();
              }
            );
          }
        }
      } else {
        JSAlert.alert(
          "Entered Passwords does not match",
          null,
          JSAlert.Icons.Failed
        );
      }
    }
  };

  React.useEffect(() => {
    getDetails();
  }, []);

  //FB 7111

  return (
    <form onSubmit={handleReset}>
      {/* FB 7111 - Start*/}
      <div className="card" style={stylestart.container}>
        <h4
          style={{
            textAlign: "left",
            paddingLeft: matches == false ? "16px" : "40px",
            paddingTop: "10px",
          }}
        >
          {/* FB 8568 */}
          Settings - Change Password {(isGuardian && login != undefined && login != "") ? " for " + login : ""}
        </h4>
        <p
          style={{
            textAlign: "left",
            paddingLeft: matches == false ? "16px" : "40px",
          }}
        >
          Please enter new password and <strong>save</strong> changes.
        </p>
      </div>
      <Grid container spacing={2} flexDirection="column" style={{
        textAlign: "left",
        paddingLeft: matches == false ? "16px" : "40px",
        paddingBottom: "30px",
      }}>
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <TextField
            type="password"
            id="OldPassword"
            name="Password"
            value={pswdResetForm.Password}
            onChange={handleInputChange}
            label="Current Password"
            variant="standard"
            required
            fullWidth
            disabled={props.userType === "admin" ? true : false}  //FB 7874
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <TextField
            type="password"
            id="NewPassword"
            name="NewPassword"
            value={pswdResetForm.NewPassword}
            onChange={handleInputChange}
            label="New Password"
            variant="standard"
            required
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <CheckCircle style={{ color: isCriteriaMet ? "green" : "lightgray" }} />
                </InputAdornment>
              ),
            }}
          />
          <StrengthMeter password={pswdResetForm.NewPassword} setIsCriteriaMet={setIsCriteriaMet} />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <TextField
            type="password"
            id="Password2"
            name="ConfirmPassword"
            value={pswdResetForm.ConfirmPassword}
            onChange={handleInputChange}
            label="Confirm Password"
            variant="standard"
            required
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <h5>Passwords must include:</h5>
          <ul className="list">
            <li>Eight or more characters</li>
            <li>At least one upper and lower case character</li>
            <li>At least one number</li>
            <li>At least one special character</li>
          </ul>
        </Grid>
        <Grid item xs={6} sm={3} md={2}>
          <Button
            type="submit"
            variant="contained"
            className={styles.navigationButton}
            disabled={isDisabled}
          >
            Save Changes
          </Button>
        </Grid>
      </Grid>
      {/* FB 7111 - End*/}
    </form>
  );
}

const button = {
  container: {
    backgroundColor: "#13607C",
    color: "white",
  },
};
const stylestart = {
  container: {
    border: "1px grey",
    backgroundColor: "#F8F8F8",
  },
};
